<template>
  <div id="quickSearch">
    <div class="mainBar">
      <div class="fList">
        <div :class="['firstClass',active === index?'active':'']" v-for="(item,index) in fList" :key="index"
          @click="slide(index)">
          <img :src="active !== index?item.img:fListActive[index].img" alt="">
          <div class="tit">{{item.text}}</div>
        </div>
      </div>
      <div :class="['sList',active === ''? 'slideUp':'slideDown']">
        <div :class="['secondClass',colIndex === index ? 'red':'']" v-for="(item,index) in sList[active]" :key="index"
          @click="search(item.text,item.goodsId,index)">
          <img :src="item.img" alt="">
          <div class="tit">{{item.text}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      slidFlag: false,
      active: 0,
      colIndex: '',
      fList: [
        {
          img: require('../assets/xiaofangzhuangbei_grey.png'),
          text: '消防装备'
        },
        {
          img: require('../assets/family_grey.png'),
          text: '家用应急'
        },
        {
          img: require('../assets/prot_grey.png'),
          text: '防护用品'
        },
        {
          img: require('../assets/resoce_grey.png'),
          text: '防疫物资'
        }
      ],
      fListActive: [
        {
          img: require('../assets/xiaofangzhuangbei_red.png'),
          text: '消防装备'
        },
        {
          img: require('../assets/family_red.png'),
          text: '家用应急'
        },
        {
          img: require('../assets/prot_red.png'),
          text: '防护用品'
        },
        {
          img: require('../assets/resoce_red.png'),
          text: '防疫物资'
        }
      ],
      sList: [
        [
          {
            img: require('../assets/fire.png'),
            text: '灭火器',
            goodsId: ''
          },
          {
            img: require('../assets/shuiqiang.png'),
            text: '水枪',
            goodsId: 10263
          },
          {
            img: require('../assets/wurenji.png'),
            text: '无人机',
            goodsId: ''
          },
          {
            img: require('../assets/robot.png'),
            text: '机器人',
            goodsId: ''
          },
          {
            img: require('../assets/xiaofangche.png'),
            text: '消防车',
            goodsId: ''
          }
        ],
        [
          {
            img: require('../assets/emergancyBeg.png'),
            text: '应急包',
            goodsId: ''
          },
          {
            img: require('../assets/miehuotan.png'),
            text: '灭火毯',
            goodsId: 10268
          },
          {
            img: require('../assets/shakeprove.png'),
            text: '缓降器',
            goodsId: 10008
          },
          {
            img: require('../assets/Poison.png'),
            text: '防毒面具',
            goodsId: 10005
          },
          {
            img: require('../assets/qiangguangshoudian.png'),
            text: '强光手电',
            goodsId: 10248
          }
        ],
        [
          {
            img: require('../assets/safecloth.png'),
            text: '救生衣',
            goodsId: 10304
          },
          {
            img: require('../assets/shoutao.png'),
            text: '手套',
            goodsId: 10003
          },
          {
            img: require('../assets/eyeglass.png'),
            text: '护目镜',
            goodsId: 10002
          },
          {
            img: require('../assets/saftybelt.png'),
            text: '安全带',
            goodsId: 10007
          },
          {
            img: require('../assets/zhangpeng.png'),
            text: '帐篷',
            goodsId: 10247
          }
        ],
        [
          {
            img: require('../assets/mouth.png'),
            text: '口罩',
            goodsId: 10259
          },
          {
            img: require('../assets/protect.png'),
            text: '防护服',
            goodsId: 10299
          },
          {
            img: require('../assets/mask.png'),
            text: '面罩',
            goodsId: 10283
          },
          {
            img: require('../assets/xishouye.png'),
            text: '洗手液',
            goodsId: 10302
          },
          {
            img: require('../assets/tempGun.png'),
            text: '额温枪',
            goodsId: 10300
          }
        ]
      ]
    }
  },
  methods: {
    reset () {
      this.active = ''
      this.slidFlag = false
      this.$emit('changePosition', this.slidFlag)
    },
    slide (index) {
      this.active = index === this.active ? '' : index
      this.slidFlag = this.active !== ''
      this.colIndex = ''
      this.$emit('changePosition', this.slidFlag)
    },
    search (key, id, index) {
      // if (key === '灭火器' || key === '无人机' || key === '机器人' || key === '消防车' || key === '应急包') {
      this.colIndex = index
      this.$emit('getSearchKey', key)
      // } else {
      //   this.$router.push({
      //     path: '/goodsdetail',
      //     query: {
      //       goodsId: id,
      //       businessId: 26359
      //     }
      //   })
      // }
    }
  },
  mounted () {
    this.$emit('changePosition', true)
  }
}
</script>

<style lang="scss" scoped>
#quickSearch {
  position: fixed;
  width: 100%;
  background: #ffffff;
  z-index: 100;
  border-top: 1px solid #eeeeee;
  .mainBar {
    display: inline-block;
    background: #ffffff;
    width: 100%;
    min-height: 108px;
    max-height: 216px;
    .fList,
    .sList {
      width: 100%;
      height: 108px;
      display: flex;
      flex-wrap: nowrap;
      overflow: hidden;
      justify-content: flex-start;
      .firstClass,
      .secondClass {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;
        align-items: center;
        img {
          display: inline-block;
          max-height: 41px;
          max-width: 46px;
          margin-bottom: 15px;
        }
        .tit {
          display: inline-block;
          font-size: 15px;
          line-height: 16px;
          color: #222222;
        }
      }
      .secondClass {
        background: #f9f9f9;
        &.red{
          .tit{
            color: #c41335;
          }
        }
      }
      .active {
        background: #f9f9f9;
        .tit {
          color: #c41335;
        }
      }
    }

    .slideUp {
      height: 0;

      transition: all 0.5s;
    }
    .slideDown {
      height: 108px;
      transition: all 0.5s;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/quickSearch.vue